module.exports = __webpack_public_path__ + "img/cifuFont.2e37f229.png";